export default __webpack_public_path__ + "static/media/accordion-arrow.69c10a14.svg";